import { Component, OnInit, Input } from '@angular/core';
import { JPathService } from '@cv-invision/cv.component-library.ux';
// States
import { ViewsService } from '../../../services/views.service';
// Components

@Component({
	selector: 'cv-review-tables',
	templateUrl: './review-tables.component.html',
	styleUrls: ['./review-tables.component.scss']
})
export class ReviewTablesComponent implements OnInit {
	// @ViewChildren('fields') myFields: QueryList<ReviewFieldsComponent>;

	@Input() field: any;
	// @Input() selectedType = '';
	// @Input() selectedTargets: any;
	@Input() nested: any;

	// document;
	// schema;
	base;
	rows;

	get document(): any {
		return this.viewsService.document;
	}
	get schema(): any {
		return this.viewsService.schema;
	}

	constructor(private viewsService: ViewsService, private jPathService: JPathService) {
		//
	}

	async ngOnInit(): Promise<void> {
		this.base = this.field.options.path;
		this.rows = this.jPathService.getValue(this.document, `$.${this.base}`);

		this.field.options.columns.forEach(column => {
			if (!('header' in column.options)) {
				const path = this.getSchemaPath(`${this.base}.${column.options.path}`);
				const header = this.jPathService.getValue(this.schema, `$.${path}.Metadata[0].DisplayText`);
				Object.assign(column.options, { header });
			}
		});
	}

	/**
	 * Return the schema path whithout index's
	 * @param path
	 */
	getSchemaPath(path: string): string {
		const pathPattern = /(\[[a-zA-z=0-9'\\]+\])/g;
		const schemaPath = path.replace(pathPattern, '');

		return schemaPath;
	}
}
